<template>
  <div :class="isMobile === 'mobile' ? 'mobile-register-panel' : 'register-panel'">
    <div class="change-panel">
      <p class="active">
        <span>用户注册</span>
        <span class="item-line"></span>
      </p>
    </div>
    <div class="login-contain">
      <el-form ref="form" :model="formData" :rules="rulePhone">
        <el-form-item prop="phone">
          <el-input class="input-style" v-model="formData.phone" placeholder="输入手机号"></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input class="input-style special-input-style" v-model="formData.code" placeholder="输入验证码">
            <span class="span-style" slot="suffix" @click="getCheckCode" v-if="timeSetting <= 0">获取验证码</span>
            <span class="span-style" style="cursor:none" slot="suffix" v-else>{{ timeSetting }}秒</span>
          </el-input>
        </el-form-item>
        <el-form-item prop="pwd">
          <el-input type="password" class="input-style" v-model="formData.pwd" placeholder="请输入密码"></el-input>
        </el-form-item>
      </el-form>
      <el-button class="login-btn" @click="registerAccount('form')">注册</el-button>
      <div class="no-account">
        已有账号？<span @click="emitParentStatus('login')">去登录</span>
      </div>
      <!--<div class="wechat-login">-->
      <!--<span>其他方式登录</span>-->
      <!--<i @click="emitParentStatus('wechat')"></i>-->
      <!--</div>-->
    </div>
  </div>
</template>

<script>
import { loginApi } from '../../api'

export default {
  name: 'registerPanel',
  props: {
    isMobile: {
      type: String,
      default: ''
    }
  },
  data() {
    let checkPhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号码'))
      } else {
        let pattern = /^[1]([3-9])[0-9]{9}$/
        if (pattern.test(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的手机号码'))
        }
      }
    }
    return {
      formData: {},
      rulePhone: {
        phone: [{ required: true, validator: checkPhone, trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      timeSetting: 0,
      isSendCode: false
    }
  },
  methods: {
    fn() {
      delay(() => {
        //执行部分
      }, 500)
    },

    getCheckCode() {
      if (/^[1]([3-9])[0-9]{9}$/.test(this.formData.phone)) {
        if (this.isSendCode) return
        this.isSendCode = true
        loginApi.registerCodeFunc(this.formData.phone).then(res => {
          this.isSendCode = false
          if (res.code === 200) {
            this.$message.success('发送成功')
            this.timeSetting = 60
            this.timeSettingFunc()
          } else {
            this.$message.error(res.msg)
          }
        }).catch(err => {
          this.isSendCode = false
        })
      } else {
        this.$message.error('请填写手机号码')
      }
    },
    timeSettingFunc() {
      let temp = setInterval(() => {
        if (this.timeSetting <= 1) {
          clearInterval(temp)
        }
        --this.timeSetting
      }, 1000)
    },
    registerAccount(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          loginApi.registFunc({
            code: this.formData.code,
            phone: this.formData.phone,
            pwd: this.formData.pwd
          }).then(res => {
            if (res.code === 200) {
              this.$store.dispatch('user/getUserInfo')
              this.$notify({
                title: '成功',
                message: '您已经注册成功！',
                type: 'success',
                duration: 500,
                onClose: () => {
                  this.$emit('handleClose')
                  this.$router.push({ name: 'industry' })
                }
              })
            } else {
              this.$message.error(res.msg)
            }
          }).catch(err => {
            console.log(err)
          })
        } else {
          this.$message.error('请填写完整')
          return false
        }
      })
    },
    emitParentStatus(val) {
      this.$emit('changePanel', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.register-panel {
  .change-panel {
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 24px;
    color: #999999;
    padding: 0 p2r(60px);

    p {
      position: relative;
      cursor: pointer;
    }

    .item-line {
      display: inline-block;
      position: absolute;
      width: p2r(48px);
      height: 2px;
      background-color: #333333;
      left: 50%;
      margin-left: -24px;
      bottom: -10px;
    }
  }

  .login-contain {
    padding: 30px 60px 0;

    .input-style {
      > > > .el-input__inner {
        height: p2r(56px);
        line-height: p2r(56px);
        border-radius: 0;
      }
    }

    .special-input-style {
      > > > .el-input__inner {
        padding-right: p2r(110px);
      }
    }

    .span-style {
      line-height: 56px;
      font-size: 16px;
      color: $bloodRed;
      margin-right: p2r(20px);
      cursor: pointer;
    }

    .login-btn {
      margin-top: p2r(40px);
      margin-bottom: p2r(20px);
      background: $bloodRed;
      color: #ffffff;
      width: 100%;
      height: p2r(60px);
      font-size: 18px;
      border-radius: 0;
    }

    .no-account {
      font-size: 16px;
      color: #999999;
      margin-top: p2r(20px);
      margin-bottom: p2r(40px);

      span {
        color: $bloodRed;
        cursor: pointer;
      }
    }

    .wechat-login {
      color: #999999;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      span {
        height: p2r(16px);
        font-size: p2r(16px);
        margin-bottom: p2r(20px);
      }

      i {
        display: inline-block;
        width: p2r(50px);
        height: p2r(50px);
        background: url("../../assets/img/login/login_wechat.png") no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
      }
    }
  }
}

.mobile-register-panel {
  .change-panel {
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: p2r(14px);
    color: #999999;
    padding: 0 p2r(70px);

    p {
      position: relative;
      cursor: pointer;
    }

    .item-line {
      display: inline-block;
      position: absolute;
      width: p2r(24px);
      height: p2r(1px);
      background-color: #333333;
      left: 50%;
      margin-left: p2r(-12px);
      bottom: p2r(-5px);
    }
  }

  .login-contain {
    padding: p2r(20px) p2r(45px) 0;

    > > > .el-form-item {
      margin-bottom: p2r(20px);
    }

    .input-style {
      > > > .el-input__inner {
        height: p2r(36px);
        line-height: p2r(36px);
        border-radius: 0;
      }
    }

    .special-input-style {
      > > > .el-input__inner {
        padding-right: p2r(75px);
      }
    }

    .span-style {
      line-height: p2r(36px);
      font-size: p2r(12px);
      color: $bloodRed;
      margin-right: p2r(10px);
      cursor: pointer;
    }

    .login-btn {
      margin-bottom: p2r(15px);
      background: $bloodRed;
      color: #ffffff;
      width: 100%;
      height: p2r(36px);
      font-size: p2r(14px);
      border-radius: 0;
    }

    .no-account {
      font-size: p2r(12px);
      color: #999999;
      margin-bottom: p2r(30px);

      span {
        color: $bloodRed;
        cursor: pointer;
      }
    }

    .wechat-login {
      color: #999999;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      span {
        height: p2r(12px);
        font-size: p2r(12px);
        margin-bottom: p2r(10px);
      }

      i {
        display: inline-block;
        width: p2r(30px);
        height: p2r(30px);
        background: url("../../assets/img/login/login_wechat.png") no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
      }
    }
  }
}

.active {
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/components/loginPanel/registerPanel.vue